import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Grid, Button } from 'semantic-ui-react';

import { DateForm, Division, SikdaeGroup, SearchInputBox } from '../Commons';

import * as cm_action from 'actions/commons';

class UserSikdaeGivenForm extends Component {
  render() {
    const { sikdaeGroup, division } = this.props,
      { submitForm, handleEntSubmit } = this.props.formFn;

    return (
      <Form onSubmit={submitForm} className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <DateForm />
                <SearchInputBox handleSubmit={submitForm} handleEntSubmit={handleEntSubmit} placeHolder={'ID, 이름'} />
              </Form.Group>
            </Grid.Column>

            <Grid.Column width={2} className="right">
              <Button content="조회" className="given-btn" color="black" inverted />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group style={{ marginBottom: 0 }}>
                <SikdaeGroup sikdaeGroup={sikdaeGroup} style={{ margin: '0 8px 3px 0' }} />
                <Division division={division} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

UserSikdaeGivenForm = connect((state) => ({
  //result of function call
  sikdaeGroup: state.commons.sikdaeGroup,
  division: state.commons.division,

  //commons
  text: state.commons.text
}))(UserSikdaeGivenForm);

export default UserSikdaeGivenForm;
